export { TRIP_INFORMATION_SET_DEPARTURE_CITY } from 'Store/constants';

export const DEFAULT_DEPARTURE_CITY = 'NO';
